import { fetchSession, unavailableMessage, type FieldErrors } from "../../api/client.js";

import type { Confirmation } from "./contract-types.js";

/**
 * 確認の口（<c>…/confirm</c>）。<b>行き先ではなく確認に出すものを返す</b>ので、
 * 共有の <c>postForm</c>（<c>{ location }</c> を受ける）とは別に持つ。トークンの扱いは同じ
 * （送る直前に取り直す）。
 */
export type ConfirmOutcome =
    | { readonly kind: "confirmed"; readonly value: Confirmation }
    | { readonly kind: "errors"; readonly errors: FieldErrors }
    | { readonly kind: "unauthorized" };

interface Problem {
    readonly errors?: Record<string, string[]>;
}

export const postConfirm = async (url: string, body: URLSearchParams): Promise<ConfirmOutcome> => {
    const { token } = await fetchSession();
    const response = await fetch(url, {
        method: "POST",
        body,
        headers: { Accept: "application/json", RequestVerificationToken: token },
    });

    if (response.status === 401) {
        return { kind: "unauthorized" };
    }
    if (response.status === 400) {
        const problem = await response.json() as Problem;
        return { kind: "errors", errors: problem.errors ?? { "": [unavailableMessage] } };
    }
    if (!response.ok) {
        return { kind: "errors", errors: { "": [unavailableMessage] } };
    }
    return { kind: "confirmed", value: await response.json() as Confirmation };
};
